import { render, staticRenderFns } from "./AccountEditor.vue?vue&type=template&id=70869ab8&scoped=true"
import script from "./AccountEditor.vue?vue&type=script&lang=js"
export * from "./AccountEditor.vue?vue&type=script&lang=js"
import style0 from "./AccountEditor.vue?vue&type=style&index=0&id=70869ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70869ab8",
  null
  
)

export default component.exports